<h2 class="mb-0">{{getActivityDescription()}}{{getPostDescription()}}</h2>
<div *ngIf="activityResult.IsComplete" class="m-4">
    <hr>
    <div *ngIf="getEncounters('Vocabulary_Identify').length > 0">
        <div class="row">
            <div class="detail-name col-3">
                Words<span *ngIf="questionTypeHasIncorrect('Vocabulary_Identify')">*</span>
            </div>
            <div class="col-8">
                <span *ngFor="let encounter of getEncounters('Vocabulary_Identify');let isLast=last">
                    <span [ngClass]="{'hasIncorrect': hasIncorrect(encounter)}">{{ getDescription(encounter)}}</span>
                    <span *ngIf="!isLast"><br> </span>
                </span>
            </div>
        </div>
        <hr>
    </div>
     <div *ngIf="getArtifacts('speech_rec').length > 0 && getEncounters('Vocabulary_Say').length > 0">
        <div class="row">
            <app-encounter-display-vocab-say [studentId]="studentID" [artifacts]="activityResult.GeneratedArtifacts" [encounters]="getEncounters('Vocabulary_Say')"></app-encounter-display-vocab-say>
        </div>
        <hr>
    </div>
    <div *ngIf="getEncounters('Phonics_Letters_Identify').length > 0">
        <div class="row">
            <div class="detail-name col-3" *ngIf="getEncounters('Phonics_Letters_Identify')">
                Letters<span *ngIf="questionTypeHasIncorrect('Phonics_Letters_Identify')">*</span>
            </div>
            <div class="col-8">
                <span *ngFor="let encounter of getEncounters('Phonics_Letters_Identify');let isLast=last">
                    <span [ngClass]="{'hasIncorrect': hasIncorrect(encounter)}">{{ getDescription(encounter) }}</span>
                    <span *ngIf="!isLast"><br> </span>
                </span>
            </div>
        </div>
        <hr>
    </div>
    <div *ngIf="getEncounters('Phonics_InitialAndFinalSoundsInWords_Identify').length > 0">
        <div class="row">
            <div class="detail-name col-3" *ngIf="getEncounters('Phonics_InitialAndFinalSoundsInWords_Identify')">
                Letters (First Sound)<span *ngIf="questionTypeHasIncorrect('Phonics_InitialAndFinalSoundsInWords_Identify')">*</span>
            </div>
            <div class="col-8">
                <span *ngFor="let encounter of getEncounters('Phonics_InitialAndFinalSoundsInWords_Identify');let isLast=last">
                    <span [ngClass]="{'hasIncorrect': hasIncorrect(encounter)}">{{ getDescription(encounter) }}</span>
                    <span *ngIf="!isLast"><br> </span>
                </span>
            </div>
        </div>
        <hr>
    </div>
    <div *ngIf="getEncounters('Phonics_SightWords_Read').length > 0">
        <div class="row">
            <div class="detail-name col-3" *ngIf="getEncounters('Phonics_SightWords_Read')">
                Sight Words<span *ngIf="questionTypeHasIncorrect('Phonics_SightWords_Read')">*</span>
            </div>
            <div class="col-8">
                <span *ngFor="let encounter of getEncounters('Phonics_SightWords_Read');let isLast=last">
                    <span [ngClass]="{'hasIncorrect': hasIncorrect(encounter)}">{{ getDescription(encounter) }}</span>
                    <span *ngIf="!isLast"><br> </span>
                </span>
            </div>
        </div>
        <hr>
    </div>
    <div *ngIf="getEncounters('Phonics_DecodableWords_Read').length > 0">
        <div class="row">
            <div class="detail-name col-3" *ngIf="getEncounters('Phonics_DecodableWords_Read')">
                Decodable Words<span *ngIf="questionTypeHasIncorrect('Phonics_DecodableWords_Read')">*</span>
            </div>
            <div class="col-8">
                <span *ngFor="let encounter of getEncounters('Phonics_DecodableWords_Read');let isLast=last">
                    <span [ngClass]="{'hasIncorrect': hasIncorrect(encounter)}">{{ getDescription(encounter) }}</span>
                    <span *ngIf="!isLast"><br> </span>
                </span>
            </div>
        </div>
        <hr>
    </div>
    <div *ngIf="getEncounters('LanguageStructures_Speaking').length > 0">
        <div class="row">
            <div class="col-3">
                Speaking<span *ngIf="questionTypeHasIncorrect('LanguageStructures_Speaking')">*</span>
            </div>
            <div class="detail-name col-8">
                <span *ngFor="let encounter of getEncounters('LanguageStructures_Speaking');let isLast=last">
                    <span [ngClass]="{'hasIncorrect': hasIncorrect(encounter)}">{{ getDescription(encounter) }}</span>
                    <span *ngIf="!isLast"><br> </span>
                </span>
            </div>
        </div>
        <hr>
    </div>
    <div *ngIf="getEncounters('LanguageStructures_Listening').length > 0">
        <div class="row">
            <div class="detail-name col-3">
                Listening<span *ngIf="questionTypeHasIncorrect('LanguageStructures_Listening')">*</span>
            </div>
            <div class="col-8">
                <span *ngFor="let encounter of getEncounters('LanguageStructures_Listening');let isLast=last">
                    <span [ngClass]="{'hasIncorrect': hasIncorrect(encounter)}">{{ getDescription(encounter) }}</span>
                    <span *ngIf="!isLast"><br> </span>
                </span>
            </div>
        </div>
        <hr>
    </div>
    <div *ngIf="hasAnyIncorrectEncounters()">
        <div class="row">
            <div class="ml-3 italic">
                *Items in red/bold were missed on the first attempt.
            </div>
        </div>
        <hr>
    </div>
    
    <div class="container">
        <div class="row">
            <div *ngFor="let artifact of activityResult.GeneratedArtifacts" [ngClass]="{'col-4': artifact.ArtifactType !== 'daisy_chain_conversation_summary'}">
                <app-artifact-display-speech-rec *ngIf="isInternalUser && artifact.SpeechRecPromptMetadata" [artifact]="artifact"></app-artifact-display-speech-rec>
                <app-artifact-display *ngIf="!isInternalUser || !artifact.SpeechRecPromptMetadata" [artifact]="artifact"></app-artifact-display>
            </div>
        </div>
    </div>
    <div *ngIf="(!activityResult.Encounters || activityResult.Encounters.length === 0) && (!activityResult.GeneratedArtifacts || activityResult.GeneratedArtifacts.length === 0)">
        <div class="row">
            <div class="ml-3 italic">
                *No student work to display for this activity.
            </div>
        </div>
        <hr>
    </div>
</div>